<template>
    <div class="container-fluid">
        <div class="row mt-2 mb-5">
            <div class="offset-md-2 col-md-8 col-12">
                <!-- stage numbering -->
                <div class="row my-2">
                    <div class="col-12 text-center">
                        <span class="text-dark-green">Information</span> &gt;
                        <span class="text-muted">Shipping</span> &gt;
                        <span class="text-muted">Payment</span>
                    </div>
                </div>

                <!-- import cart review -->
                <app-cart-review class="my-3"></app-cart-review>

                <form @submit.prevent="submitInformation">
                    <!-- display fields to receive guest shopper details -->
                    <template v-if="!loggedInUser">
                        <div class="row mt-4">
                            <div class="col-12">
                                <!-- login link for mobile display alone -->
                                <div class="d-sm-none mb-3 font-weight-bold">
                                    <p class="m-0 p-0">
                                        Already have an account? 
                                        <router-link :to="{ name: 'signin' }" class="text-dark-green">
                                            Log in
                                        </router-link>
                                    </p>
                                </div>
                                <div class="card">
                                    <div class="bg-silver p-2 font-weight-bold">
                                        <!-- login link for desktop display alone -->
                                        <div class="float-sm-right mb-3 m-sm-0 d-none d-sm-block">
                                            <p class="m-0 p-0">
                                                Already have an account? 
                                                <router-link :to="{ name: 'signin' }" class="text-dark-green">
                                                    Log in
                                                </router-link>
                                            </p>
                                        </div>
                                        <div class="float-sm-left">
                                            <p class="m-0"><i class="fas fa-user"></i> Contact Information</p>
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- shoppers email address -->
                        <div class="row mt-3 mb-4">
                            <div class="col-12">
                                <div class="mt-0">
                                    <label class="form-check-label text-dark-green">Email Address</label>
                                    <input v-model="email" type="email" ref="email" required class="form-control no-lines">
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- display saved addresses -->
                    <div v-if="loggedInUser" class="row mt-3">
                        <div class="col-12 font-weight-bold">
                            <div class="card bg-silver">
                                <div class="p-2">
                                    <p class="m-0"><i class="fas fa-map-marker-alt"></i> Saved Addresses</p>
                                </div>
                                <select v-model="selectedAddress" @change="autoAssignValuesFxn" ref="country" class="custom-select no-lines bg-white" style="border-color: #DFDFDF;">
                                    <option selected disabled :value="null">select address</option>
                                    <option v-for="(address, i) in theAddresses" :key="i" :value="address">
                                        {{address.firstName | capitalize}} {{address.lastName | capitalize}}, 
                                        {{address.state | capitalize}}, {{address.alphaCode.toUpperCase()}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    
                    <!-- shoppers shipping title -->
                    <div class="row mt-3">
                        <div class="col-12 font-weight-bold">
                            <div class="card">
                                <div class="bg-silver p-2">
                                    <p class="m-0"><i class="fas fa-shipping-fast"></i> Shipping Details</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- shoppers shipping address -->
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-sm-6 col-12">
                                    <div class="mt-3">
                                        <label class="form-check-label text-dark-green">First Name</label>
                                        <input v-model="firstName" type="text" ref="firstName" required class="form-control no-lines text-capitalize">
                                    </div>
                                </div>
                                <div class="col-sm-6 col-12">
                                    <div class="mt-3">
                                        <label class="form-check-label text-dark-green">Last Name</label>
                                        <input v-model="lastName" type="text" ref="lastName" required class="form-control no-lines text-capitalize">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="mt-3">
                                <label class="form-check-label text-dark-green">Address 1</label>
                                <input v-model="address" type="text" ref="address" required class="form-control no-lines">
                            </div>
                            <div class="mt-3">
                                <label class="form-check-label text-dark-green">Address 2 (optional)</label>
                                <input v-model="address2" type="text" ref="address2" class="form-control no-lines">
                            </div>
                            <div class="mt-3">
                                <label class="form-check-label text-dark-green">City</label>
                                <input v-model="city" type="text" ref="city" required class="form-control no-lines text-capitalize">
                            </div>
                        </div>
                        
                        <div class="col-12">
                            <div class="row">
                                <div class="col-sm-4 col-12">
                                    <div class="mt-3">
                                        <label class="form-check-label text-dark-green">State</label>
                                        <input v-model="state" type="text" ref="state" required class="form-control no-lines text-capitalize">
                                    </div>
                                </div>
                                <div v-if="theCountries" class="col-sm-4 col-12">
                                    <div class="mt-3">
                                        <label class="form-check-label text-dark-green">Country</label>
                                        <select v-model="selectedCountry" @change="countryFxn" ref="country" class="custom-select no-lines" style="border-color: #DFDFDF;">
                                            <option selected disabled value="">select country</option>
                                            <option v-for="(x, i) in theCountries" :key="i" :value="x.country">{{x.country | capitalize}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4 col-12">
                                    <div class="mt-3">
                                        <label class="form-check-label text-dark-green">Zip Code (optional)</label>
                                        <input v-model="zipCode" type="text" ref="zipCode" class="form-control no-lines">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="mt-3">
                                <label class="form-check-label text-dark-green">Phone (optional)</label>
                                <input v-model="phone" type="text" ref="phone" class="form-control no-lines">
                            </div>
                        </div>

                        <div v-if="!selectedAddress" class="col-12">
                            <div class="mt-3">
                                <div class="form-check">
                                    <label class="form-check-label" for="saveInfo">
                                        <input v-model="saveInfo" class="form-check-input" type="checkbox" value="" id="saveInfo">
                                        Save this address for next time 
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- display alert messages for mobile -->
                    <div v-if="msg !== ''" :class="`alert alert-${color} text-center mt-3 p-1`" role="alert">
                        <i class="fas fa-exclamation-circle fa-sm"></i> {{ msg }}
                    </div>
                    
                    <!-- continue to shipping button -->
                    <div class="row mt-4">
                        <div class="col-12">
                            <div class="float-sm-right">
                                <button @click.prevent="submitInformation" class="btn btn-dark-green form-control">
                                    Continue to Shipping
                                </button>
                            </div>
                            <div class="float-sm-left">
                                <p class="text-center m-0 pt-2">
                                    <router-link :to="{ name: 'shopping-cart' }">
                                        <i class="fas fa-chevron-left fa-xs"></i> Return to Cart
                                    </router-link>
                                </p>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CartReview from './CartReview.vue';
import LayoutGeneral from '@/layouts/General.vue'

export default {
    name: "Information",
    data() {
        return {
            email: '',
            firstName: '',
            lastName: '',
            phone: '',
            address: '',
            address2: '',
            city: '',
            state: '',
            selectedCountry: '',
            alphaCode: '',
            country: '',
            zipCode: '',
            saveInfo: false,
            showPassword: false,
            showGuestCheckout: false,
            showMemberCheckout: false,
            selectedAddress: null,
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['fetchCountries']),
        autoAssignValuesFxn() {
            // variable required to hold the user data if found
            let userObj = null

            // assign values from logged in user to overwrite the details from local storage
            if(this.loggedInUser){ userObj = this.loggedInUser }
            
            // if user already have a shopper details storage on local-storage overright userObj values
            let localStorageSHPDetails = JSON.parse(localStorage.getItem('ani_items_shp')) 
            if(localStorageSHPDetails) { userObj = localStorageSHPDetails }

            // assign the loggedIn user selected address here if any
            if(this.selectedAddress){ userObj = this.selectedAddress }

            // ensure the email address remains as the logged in shopper own
            if(this.loggedInUser){ userObj.email = this.loggedInUser.email }
            
            // kill the fxn if no value was supplied into userObj
            if(!userObj) { return }
            
            // check if user has only the name property
            if(userObj.name && !userObj.firstName && !userObj.lastName){
                let splittedName = userObj.name.split(" ")
                userObj.firstName = splittedName[0]
                userObj.lastName = splittedName[1]
            }

            // assign the values back to the vmodel inputs
            this.email = userObj.email
            this.firstName = userObj.firstName
            this.lastName = userObj.lastName
            this.phone = userObj.phone
            this.address = userObj.address
            this.address2 = userObj.address2
            this.city = userObj.city
            this.state = userObj.state
            this.alphaCode = userObj.alphaCode
            this.country = userObj.country
            this.zipCode = userObj.zipCode
            this.saveInfo = userObj.saveInfo
            // just for display on the user country information field, nothing else
            this.selectedCountry = userObj.country 
        },
        countryFxn(){
            if(this.selectedCountry){
                let countryObj = this.theCountries.find(data => data.country == this.selectedCountry)
                if(countryObj){
                    this.alphaCode = countryObj.alphaCode
                    this.country = countryObj.country
                }
            }
        },
        submitInformation() {
            if(this.email === ''){ this.msg = "Enter your email address"; return }
            if(this.firstName === ''){ this.msg = "Enter your first name"; return }
            if(this.lastName === ''){ this.msg = "Enter your last name"; return }
            if(this.address === ''){ this.msg = "Enter your address street"; return }
            if(this.city === ''){ this.msg = "Enter your address city"; return }
            if(this.state === ''){ this.msg = "Enter your address state"; return }
            if(this.alphaCode == ''){ this.msg = "Select your country to obtain the alphaCode"; return }
            if(this.country == ''){ this.msg = "Select your address country"; return }

            let shopperObj = {
                email: this.email,
                firstName: this.firstName,
                lastName: this.lastName,
                phone: this.phone,
                address: this.address,
                address2: this.address2,
                city: this.city,
                state: this.state,
                alphaCode: this.alphaCode,
                country: this.country,
                zipCode: this.zipCode,
                saveInfo: this.saveInfo
            }
            
            // add the userId only when shopper is logged in
            if(this.loggedInUser){ shopperObj.userId = this.loggedInUser._id }

            // check if user already have a shopper details storage on local-storage
            let localStorageSHPDetails = JSON.parse(localStorage.getItem('ani_items_shp')) 
            // remove the previously saved shopper details if any
            if(localStorageSHPDetails) {
                localStorage.removeItem('ani_items_shp')
            }
            // save the latest shopper details to local storage as string
            localStorage.setItem('ani_items_shp', JSON.stringify(shopperObj))

            // redirect to shipping page
            this.$router.push({
                name: 'checkout-shipping'
            }).catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['authenticated', 'user', 'setCountries', 'setAddresses']),
        loggedInUser() {
            if(this.authenticated && this.user){
                return this.user
            }
            return false
        },
        theCountries() {
            if(this.setCountries){
                return this.setCountries
            }
            return []
        },
        theAddresses() {
            if(this.setAddresses) {
                return this.setAddresses
            }
            return false
        },
    },
    components: {
        appCartReview: CartReview
    },
    created() {
        this.autoAssignValuesFxn()
        this.fetchCountries().then(() => {}).catch((e) => {})
        this.$emit('update:layout', LayoutGeneral);
    },
}
</script>
